const STATUS = {
  COMPLETE: 1,
  CANCEL: 2
}

const STATUS_HISTORY_LABEL = {
  COMPLETE: 'common.common_register',
  CANCEL: 'order.order_invalid'
}

export default {
  STATUS,
  STATUS_HISTORY_LABEL
}
